import { z } from 'zod';

// Where a validation's error attaches in the rendered UI.
//   field:    error renders under the named bind's field UI slot
//   section:  error renders on the section's header banner
//   tab:      error renders next to the tab title (badge / indicator)
//   surface:  error renders in the surface-level errors panel
//
// Field/section/tab require an `id` (bind path, section path, tab path).
// Surface has no id — there's only one surface root per mount.
export const ValidationAttachTargetZod = z.discriminatedUnion('type', [
  z.object({ type: z.literal('field'), id: z.string().min(1) }).strict(),
  z.object({ type: z.literal('section'), id: z.string().min(1) }).strict(),
  z.object({ type: z.literal('tab'), id: z.string().min(1) }).strict(),
  z.object({ type: z.literal('surface') }).strict(),
]);

export type ValidationAttachTarget = z.infer<typeof ValidationAttachTargetZod>;
